import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { Button } from './UI';
import { store } from '../stores/mainStore';
import { ButtonBar } from './UI';
import { integration } from '../integration';
import { Sprite } from './Sprite';

const ExitPage = styled.div`
	padding-top: ${p =>  0}%;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: ${p => 100}%;
	height: 100%;
	padding-top: 0%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: 90%;
	margin: 25vw auto 0;
	@media (min-aspect-ratio: 9/15){
		margin: 0 auto;
	}
	& .button-bar {
		margin-top: 2vw;
	}
`

const Message = styled(Sprite)`
	width: 90vw;
	margin: 0 auto;
	@media (min-aspect-ratio: 9/15){
		width: 80vw;
	}
`

export class ModalResume extends Component {

	exit = () => {
		// window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`resume_game`);
		store.modal = '';
	}

	render() {

		return (
			<ExitPage>
				<Content>
					<CloseBox>
						<Message localize sprite="box_resuming_msg.png" />
						<ButtonBar>
							<Button blue_ok onClick={this.exit}/>
						</ButtonBar>
					</CloseBox>
				</Content>
			</ExitPage>
		);
	}
}
